import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { doc, getDoc, getDocs, collection } from "firebase/firestore";
import { Typography, Box } from "@mui/material";

export default function ShowDienstNummerSubcollections({ dateStart, dateEnd, dienstLinie }) {
  const [dienstNummerList, setDienstNummerList] = useState([]);
  const [dienstData, setDienstData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // Normalize dienstLinie to array of two-digit strings
  const normalizeDienstLinieArray = (value) => {
    if (Array.isArray(value)) {
      return value.map((item) => String(item).replace(/\D/g, "").slice(0, 2)).filter(x => x.length === 2);
    }
    if (typeof value === "string") {
      return value.split(",").map((item) => String(item).replace(/\D/g, "").slice(0, 2)).filter(x => x.length === 2);
    }
    return [];
  };
  const dienstLinieArr = normalizeDienstLinieArray(dienstLinie);

  useEffect(() => {
    if (!dateStart || !dateEnd) return;
    const fetchData = async () => {
      setLoading(true);
      setError("");
      setDienstNummerList([]);
      setDienstData({});
      try {
        const docId = `${dateStart}__${dateEnd}`;
        const docRef = doc(db, "FahrplaenePages", docId);
        const docSnap = await getDoc(docRef);
        if (!docSnap.exists()) {
          setError("Kein FahrplaenePages-Dokument gefunden.");
          setLoading(false);
          return;
        }
        const data = docSnap.data();
        let dienstList = data.dienstNummerList || [];
        // Filter dienstNummerList to only those matching dienstLinie (first two digits)
        if (dienstLinieArr.length > 0) {
          dienstList = dienstList.filter(dn => dienstLinieArr.includes(dn.substring(0, 2)));
        }
        setDienstNummerList(dienstList);
        const allDienstData = {};
        for (const dienstNummer of dienstList) {
          const subColRef = collection(db, "FahrplaenePages", docId, dienstNummer);
          const subDocsSnap = await getDocs(subColRef);
          allDienstData[dienstNummer] = subDocsSnap.docs.map(d => ({ id: d.id, ...d.data() }));
        }
        setDienstData(allDienstData);
      } catch (e) {
        setError("Fehler beim Laden der dienstNummer-Subcollections.");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [dateStart, dateEnd, dienstLinie]);

  if (!dateStart || !dateEnd) return null;
  if (loading) return <Typography sx={{ mt: 1 }}>Lade dienstNummer-Subcollections...</Typography>;
  if (error) return <Typography color="error" sx={{ mt: 1 }}>{error}</Typography>;
  if (!dienstNummerList.length) return <Typography variant="body2" color="text.secondary">Noch keine Extraktion durchgeführt.</Typography>;

  return (
    <Box>
      {dienstNummerList.map((dienstNummer) => (
        <Box key={dienstNummer} sx={{ mb: 1, p: 1, border: '1px solid #ccc', borderRadius: 1 }}>
          <Typography variant="body2" sx={{ fontWeight: 700 }}>dienstNummer: {dienstNummer}</Typography>
          {dienstData[dienstNummer] && dienstData[dienstNummer].length > 0 ? (
            dienstData[dienstNummer].map((entry, i) => (
              <Box key={i} sx={{ ml: 2, mb: 1 }}>
                {Object.entries(entry).filter(([k]) => k !== 'id').map(([k, v]) => (
                  <Typography key={k} variant="body2"><b>{k}:</b> {JSON.stringify(v)}</Typography>
                ))}
              </Box>
            ))
          ) : (
            <Typography variant="body2" color="text.secondary">Keine Daten.</Typography>
          )}
        </Box>
      ))}
    </Box>
  );
}